import axios from './financeiroApi';

const pendenciasCobrancaApi = () => {
  const getPath = () => '/api/v1/backend/pendencias-cobranca';

  return {
    buscar: (formaCobranca, clienteId) => {
      return axios.get(`${getPath()}?formaCobranca=${formaCobranca}&clienteId=${clienteId}`);
    },
  };
};

export { pendenciasCobrancaApi };
